import { Link } from "react-router-dom";

import { Card } from "../../components/ui/Card";
import { PageHeader } from "../../components/ui/PageHeader";
import { t } from "../../lib/i18n";
import { useLocale } from "../../lib/useLocale";

export function ReportsIndexPage() {
  useLocale();

  const tiles: { to: string; titleKey: string; bodyKey: string }[] = [
    { to: "/reports/device-health", titleKey: "reports.tile.deviceHealth", bodyKey: "reports.tile.deviceHealthBody" },
    { to: "/reports/app-adoption", titleKey: "reports.tile.appAdoption", bodyKey: "reports.tile.appAdoptionBody" },
  ];

  return (
    <div>
      <PageHeader
        eyebrow={t("reports.eyebrow")}
        title={t("reports.indexTitle")}
        subtitle={t("reports.indexSubtitle")}
      />
      <div className="card-grid">
        {tiles.map((tile) => (
          <Link
            key={tile.to}
            to={tile.to}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Card title={t(tile.titleKey)}>
              <p style={{ color: "var(--color-text-muted)" }}>{t(tile.bodyKey)}</p>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
